<template>
  <div class="customer-details">
    <rCenterHeader :list="headerMenu"></rCenterHeader>
    <div class="customer-content common-flex">
      <div class="details">
        <div class="header">
          <img class="header-img" v-if="imgPath" :src="imgPath" alt="" />
          <img class="header-img" v-else src="../../assets/images/defaultHeader.png" alt="" />
          <img
            @click="changeHeader"
            class="edit-icon common-hover"
            src="../../assets/images/xgtx.png"
            alt=""
          />
        </div>
        <div class="name">{{ customerDetail.custName }}</div>
        <div class="gender">{{ customerDetail.genderName }}</div>
        <div class="options common-flex common-justify-between">
          <div v-for="(item, index) in optionsBtn" :key="index">
            <img :src="item.img" alt="" />
          </div>
        </div>
        <div class="msg common-flex common-justify-between">
          <div v-for="(item, index) in userBody" :key="index">
            <div class="num">{{ item.num?item.num:'-' }}</div>
            <div class="label">{{ item.label }}</div>
            <div class="unit">{{ item.unit }}</div>
          </div>
        </div>
        <!-- 个人信息 -->
        <div
          class="personal-informaion"
          v-if="basicList && basicList.length > 0"
        >
          <div class="common-flex common-justify-between informaion-item">
            <div class="msg-title">{{ $t("customer.personalInformaion") }}</div>
            <div
              class="iconfont iconbianji common-hover"
              @click="edit(1)"
            ></div>
          </div>
          <div
            v-for="(item, index) in basicList"
            :key="index"
            class="common-flex common-justify-between informaion-item"
          >
            <div class="informaion-label">{{ item.label }}</div>
            <div class="informaion-content">
              {{ item.inputValue || item.dateValue }}
            </div>
          </div>
        </div>
        <!-- 个人特体信息 -->
        <div
          class="personal-informaion"
          v-if="
            customerDetail.customerSpecialList &&
            customerDetail.customerSpecialList.length > 0
          "
        >
          <div class="common-flex common-justify-between informaion-item">
            <div class="msg-title">{{ $t("customer.dressStyle") }}</div>
            <div
              class="iconfont iconbianji common-hover"
              @click="edit(2)"
            ></div>
          </div>
          <div
            v-for="(item, index) in customerDetail.customerSpecialList"
            :key="index"
            class="common-flex common-justify-between informaion-item"
          >
            <div class="informaion-label">{{ item.desName }}</div>
            <div class="informaion-content">{{ item.specName }}</div>
          </div>
        </div>
        <!-- 净体信息 -->
        <div
          class="personal-informaion"
          v-if="
            customerDetail.customerSizeList &&
            customerDetail.customerSizeList.length > 0
          "
        >
          <div class="common-flex common-justify-between informaion-item">
            <div class="msg-title">{{ $t("customer.bodyMeasurements") }}</div>
            <div
              class="iconfont iconbianji common-hover"
              @click="edit(3)"
            ></div>
          </div>
          <div
            v-for="(item, index) in customerDetail.customerSizeList"
            :key="index"
            class="common-flex common-justify-between informaion-item"
          >
            <div class="informaion-label">{{ item.partName }}</div>
            <div class="informaion-content">
              {{ item.partSize }} {{ customerDetail.heightUnitName }}
            </div>
          </div>
        </div>
        <div
          class="personal-informaion"
          v-if="
            customerDetail.cySizeList &&
            customerDetail.cySizeList.length > 0
          "
        >
           <div class="common-flex common-justify-between informaion-item">
            <div class="msg-title">{{ $t("addCustomer.tailor") }}</div>
            <div
              class="iconfont iconbianji common-hover"
              @click="edit(4)"
            ></div>
          </div>
          <div
            v-for="(item, index) in customerDetail.cySizeList"
            :key="index"
            class="informaion-item"
          >
            <div class="informaion-label" style="font-weight:550">{{ item.name }}</div>
            <div v-for="(citem,cindex) in item.partList" :key="cindex">
              <div class="common-flex common-justify-between informaion-item">
                <div class="informaion-label">{{ citem.name }}</div>
                <div class="informaion-content">{{ citem.partSize }}{{ customerDetail.heightUnitName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="order">
        <div class="order-title">{{ $t("customer.orderlist") }}</div>
        <rCustomerOrder
          @changeTip="changeTip"
          @addTip="addTip"
          @delTips="delTips"
          @details="details"
          @buyAgain="handleBuyAgain"
          :widthConfig="widthConfig"
          :config="item"
          v-for="(item, index) in orderList"
          :key="index"
          :index="index"
        ></rCustomerOrder>
        <rNull
          v-if="orderList.length == 0"
          imgStyle="width:300px;margin:40px auto"
          titleStyle="font-size:16px;color:#999"
          :title="$t('noResult')"
        ></rNull>
        <div
          class="common-flex common-justify-center"
          v-if="total"
          style="margin-top: 20px; padding-bottom: 20px"
        >
          <Page
            :total="total"
            @on-change="changePage"
            :page-size="cusParams.pageSize"
            show-total
          >
            <span>{{ $t("total") }} {{ total }} {{ $t("recoprds") }}</span>
          </Page>
        </div>
      </div>
      <div class="remark">
        <div
          class="
            common-flex common-justify-between common-align-center
            remark-top
          "
        >
          <div class="order-title">{{ $t("customer.appointmentContent") }}</div>
          <div
            class="iconfont icontianjia common-hover"
            @click="addAppointment"
          ></div>
        </div>
        <div v-if="appointmentList && appointmentList.length > 0">
          <rRemarkCard
            @editAppointment="editAppointment"
            @updateAppointment="updateAppointment"
            v-for="(item, index) in appointmentList"
            :key="index"
            :config="item"
          ></rRemarkCard>
        </div>
        <div v-else>
          <rNull
            v-if="appointmentList.length == 0"
            imgStyle="width:100px;margin:10px auto"
            titleStyle="font-size:12px;color:#999"
            :title="$t('noResult')"
          ></rNull>
        </div>
        <div
          style="margin-top: 30px"
          class="
            common-flex common-justify-between common-align-center
            remark-top
          "
        >
          <div class="order-title">{{ $t("customer.customerNotes") }}</div>
          <div
            class="iconfont icontianjia common-hover"
            @click="addNotes"
          ></div>
        </div>
        <div
          v-for="(item, index) in noteList"
          :key="index"
          class="notes common-flex common-justify-between common-align-center"
        >
          <div style="width: 200px">{{ item.content }}</div>
          <div
            class="iconfont iconshanchudizhi common-hover"
            @click="delNote(item)"
          ></div>
        </div>
        <rNull
          v-if="noteList.length == 0"
          imgStyle="width:100px;margin:10px auto"
          titleStyle="font-size:12px;color:#999"
          :title="$t('noResult')"
        ></rNull>
        <!-- <div class="notes" style="border-left: 3px solid #081938">
          Customers like loose clothes and dark colors
        </div> -->
      </div>
    </div>
    <!-- 预约弹框 -->
    <rAppointmentModal
      :appointmentShow="appointmentShow"
      @handlerAppointmentShow="handlerAppointmentShow"
      @submitAppointment="submitAppointment"
      :customerId="customerId"
      :editAppointment="editAppointmentShow"
      :appointmentDetails="appointmentDetails"
    ></rAppointmentModal>
    <!-- 备注弹框 -->
    <rNoteModal
      :noteShow="noteShow"
      :customerId="customerId"
      @handlnoteShow="handlnoteShow"
      @submitNote="submitNote"
    ></rNoteModal>
    <!-- 修改头像 -->
    <rChangeHeaderModal
      :headerShow="headerShow"
      :customerId="customerId"
      :imgPath="imgPath"
      :attachId="attachId"
      @handleHeaderShow="handleHeaderShow"
      @saveHeader="saveHeader"
    ></rChangeHeaderModal>
    <!-- 修改提示 -->
    <rEditTipModal
      @updateCart="updateCart"
      tipType="cart"
      :chooseOrderId="chooseOrderId"
      :chooseContent="chooseContent"
      :tipShow="tipShow"
      @handlerTipShow="handlerTipShow"
    ></rEditTipModal>
    <!-- 编辑用户 -->
    <rAddNewCustomer
      :addNew="editCustomer"
      :edit="editItem"
      :custInfo="custInfo"
      :customerId="customerId"
      @handlerAdd="handlerAdd"
      @updateList="update"
    ></rAddNewCustomer>
    <Modal
      v-model="orderDetails"
      style="height: 90%"
      footer-hide
      fullscreen
      title=""
    >
      <div class="title-box">
        <div class="title">{{ $t("saveItems.CheckOptions") }}</div>
        <div
          @click="closeDetails"
          class="common-hover iconfont iconguanbi"
        ></div>
      </div>
      <rOrderDetails
        :config="orderMsg"
        :hideStep="true"
        detailsType="picture"
      ></rOrderDetails>
    </Modal>
  </div>
</template>

<script>
import rCenterHeader from "../../components/r-center-header";
import rCustomerOrder from "../../components/r-customer-order";
import rRemarkCard from "../../components/r-remark-card";
import rAppointmentModal from "../../components/r-appointment-modal";
import rNoteModal from "../../components/r-note-modal";
import rChangeHeaderModal from "../../components/r-change-header-modal";
import rEditTipModal from "../../components/r-edit-tip-modal";
import rAddNewCustomer from "../../components/r-add-new-customer";
import rOrderDetails from "../../components/r-order-details";
import rNull from "../../components/r-null";
import { mapActions } from "vuex";
export default {
  name: "customer-details",
  components: {
    rCenterHeader,
    rCustomerOrder,
    rRemarkCard,
    rAppointmentModal,
    rNoteModal,
    rChangeHeaderModal,
    rEditTipModal,
    rAddNewCustomer,
    rOrderDetails,
    rNull,
  },
  data() {
    return {
      orderMsg: "",
      orderDetails: false,
      chooseOrderId: "",
      chooseContent: "",
      // 预约信息
      appointmentDetails: "",
      // 是否编辑预约信息
      editAppointmentShow: false,
      // 预约信息列表
      appointmentList: [],
      // 附件id
      attachId: "",
      // 是否是i编辑
      editItem: 0,
      // 编辑客服显示
      editCustomer: false,
      // 客户特体尺寸等信息
      imgPath: "",
      custInfo: {},
      // 客户总祥情
      customerDetail: "",
      // 用户id
      customerId: "",
      // 订单列表宽度
      widthConfig: {
        allWidth: "760",
        code: "235",
        total: "167",
        price: "147",
        status: "96",
      },
      // tip修改
      tipShow: false,
      //   预约弹框
      appointmentShow: false,
      //   备注弹框
      noteShow: false,
      //   修改头像弹框
      headerShow: false,
      // 头部面包屑
      headerMenu: [
        {
          name: this.$t("customer.crumbs.individualAccount"),
          to: "./user",
        },
        {
          name: this.$t("customer.crumbs.customerManagement"),
          to: "./customerList",
        },
        {
          name: "",
        },
      ],
      // 备注列
      noteList: [],
      //  身体数据
      userBody: [
        {
          num: 185,
          label: this.$t("customer.height"),
          unit: "Inch",
        },
        {
          num: 76,
          label: this.$t("customer.weight"),
          unit: "Inch",
        },
        {
          num: 23,
          label: this.$t("customer.orderQty"),
        },
      ],
      //   按钮组
      optionsBtn: [
        {
          img: require("../../assets/images/yuyue.png"),
        },
        {
          img: require("../../assets/images/dmxd.png"),
        },
        {
          img: require("../../assets/images/ktxd.png"),
        },
      ],
      cusParams: {
        customerId: "",
        type: 2,
        pageNum: 1,
        pageSize: 20,
      },
      // 预约参数
      paramsApponintment: {
        type: 1,
        pageSize: 20,
        pageNum: 1,
        customerId: "",
      },
      // 备注参数
      paramsNote: {
        type: 2,
        pageSize: 20,
        pageNum: 1,
        customerId: "",
      },
      orderList: [],
      basicList: [
        {
          label: this.$t("customer.basicList.name"),
          must: true,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.nickname"),
          must: true,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.gender"),
          must: true,
          type: "select",
          value: "",
          list: [],
        },
        {
          label: this.$t("customer.basicList.height"),
          must: true,
          inputValue: "",
          type: "iptSelect",
          value: "",
          list: [],
        },
        {
          label: this.$t("customer.basicList.weight"),
          inputValue: "",
          must: true,
          type: "iptSelect",
          value: "",
          list: [],
        },

        {
          label: this.$t("customer.basicList.phone"),
          must: true,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.email"),
          must: false,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.address"),
          must: false,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.DOB"),
          must: false,
          type: "date",
          inputValue: "",
        },
      ],
      total: 0,
    };
  },
  methods: {
    ...mapActions([
      "getOneAction", //客户详情
      "listCustomerNoteAction", //预约备注列
      "deleteCustomerNoteAction", //删除
      "getOrderCartListAction", //订单列表
      "saveOrderLabelsAction", //s删除tips
      "getCartOrderDetailAction", //订单详情
    ]),
    // 隐藏订单列表 操作
    closeDetails() {
      this.orderDetails = false;
    },
    // 删除标签
    delTips(labelItem) {
      // 从订单的标签列表中删除特定标签
      const orderId = labelItem.orderId;
      const labelIdToRemove = labelItem.id;
      
      // 找到对应的订单
      const order = this.orderList.find(item => item.orderId === orderId);
      if (!order || !order.labels) {
        return;
      }
      
      // 过滤出其他标签
      const remainingLabelIds = order.labels
        .filter(label => label.id !== labelIdToRemove)
        .map(label => label.id)
        .join(',');
      
      this.saveOrderLabelsAction({
        orderId: orderId,
        labelIds: remainingLabelIds
      }).then((res) => {
        if (res.code == 0) {
          this.$Message.success('标签已删除');
          this.getOrderCartList();
        } else {
          this.$Message.error(res.message || '删除失败');
        }
      });
    },
    changePage(e) {
      this.cusParams.pageNum = e;
      this.getOrderCartList();
    },
    updateCart(isDel) {
      if (!isDel) {
        this.tipShow = false;
      }
      // this.orderList = []
      // this.params.pageNum = 1;
      this.getOrderCartList();
    },
    // 订单列表
    getOrderCartList() {
      this.cusParams.customerId = this.customerId;
      this.getOrderCartListAction(this.cusParams).then((res) => {
        this.orderList = res.data;
        this.total = res.total;
      });
    },
    // 删除备注
    delNote(e) {
      this.$Modal.confirm({
        title: this.$t("delMsg.tips"),
        content: this.$t("delMsg.content"),
        okText: this.$t("user.determine"),
        cancelText: this.$t("user.cancel"),
        onOk: () => {
          this.deleteCustomerNoteAction({ id: e.id }).then((res) => {
            if (res.code == 0) {
              this.listCustomerNotea();
            }
          });
        },
      });
    },
    // 编辑预约信息
    editAppointment(e) {
      // console.log('??')
      this.appointmentShow = true;
      this.editAppointmentShow = true;
      this.appointmentDetails = e;
    },
    // 预约列表
    updateAppointment() {
      this.listCustomerNote();
    },
    // 预约列
    listCustomerNote() {
      this.paramsApponintment.customerId = this.$route.query.id;
      this.listCustomerNoteAction(this.paramsApponintment).then((res) => {
        // console.log("res", res);
        this.appointmentList = res.data;
      });
    },
    // 备注列
    listCustomerNotea() {
      this.paramsNote.customerId = this.$route.query.id;
      this.listCustomerNoteAction(this.paramsNote).then((res) => {
        // console.log("res", res);
        this.noteList = res.data;
      });
    },
    // 提交预约
    submitAppointment() {
      this.appointmentShow = false;
      this.listCustomerNote();
    },
    // 提交备注
    submitNote() {
      this.noteShow = false;
      // this.listCustomerNote();
      this.listCustomerNotea();
    },
    update() {
      this.editCustomer = false;
      this.getOne();
    },
    handlerAdd() {
      this.editCustomer = false;
    },
    // 获得详情
    getOne() {
      this.getOneAction({ id: this.customerId }).then((res) => {
        // this.headerMenu[2].name = res.data.shortName
        this.$set(this.headerMenu[2], "name", res.data.custName);
        this.custInfo.heightUnit = res.data.heightUnit
        this.custInfo.heightUnitName = res.data.heightUnitName
        // 身高体重赋值
        this.userBody[0].num = res.data.height;
        this.userBody[0].unit = res.data.heightUnitName;
        this.userBody[1].num = res.data.weight;
        this.userBody[1].unit = res.data.weightUnitName;
        this.userBody[2].num = res.data.orderCount;
        this.customerDetail = res.data;
        this.imgPath = res.data.imagePath;
        this.attachId = res.data.attachId;
        this.basicList[0].inputValue = res.data.custName;
        this.basicList[1].inputValue = res.data.shortName;
        this.basicList[2].value = res.data.genderId;
        this.basicList[2].inputValue = res.data.genderName;
        this.basicList[3].inputValue = res.data.height;
        this.basicList[3].value = Number(res.data.heightUnit);
        this.basicList[4].inputValue = res.data.weight;
        this.basicList[4].value = Number(res.data.weightUnit);
        this.basicList[5].inputValue = res.data.phone;
        this.basicList[6].inputValue = res.data.email;
        this.basicList[7].inputValue = res.data.address;
        this.basicList[8].inputValue = res.data.birthdate;
        // this.custInfo = JSON.parse(res.data.custInfo);
        // this.custInfo.basicList.map((item) => {
        //   if (item.type == "select") {
        //     item.list.map((citem) => {
        //       if (citem.id == item.value) {
        //         item.inputValue = citem.name;
        //       }
        //     });
        //   }
        // });
      });
    },
    // 编辑
    edit(e) {
      this.custInfo.basicList = this.basicList;
      this.custInfo.customerSpecialList =
        this.customerDetail.customerSpecialList;
      this.custInfo.customerSizeList = this.customerDetail.customerSizeList;
      this.custInfo.cySizeList = this.customerDetail.cySizeList;
      this.editItem = e;
      this.editCustomer = true;
      console.log("this.custInfo", this.custInfo);
    },
    //   修改tip
    changeTip(e) {
      this.tipShow = true;
      this.chooseOrderId = e.orderId;
      this.chooseContent = e.labels || [];
    },
    // 修改tip
    addTip(e) {
      this.tipShow = true;
      this.chooseOrderId = e.orderId;
      this.chooseContent = e.labels || [];
    },
    //   隐藏tip
    handlerTipShow() {
      this.tipShow = false;
    },
    //   新增预约
    addAppointment() {
      this.appointmentShow = true;
      this.editAppointmentShow = false;
    },
    // 隐藏预约
    handlerAppointmentShow() {
      this.appointmentShow = false;
    },
    //   新增备注
    addNotes() {
      this.noteShow = true;
    },
    // 隐藏备注
    handlnoteShow() {
      this.noteShow = false;
    },
    //  修改头像
    changeHeader() {
      this.headerShow = true;
    },
    // 隐藏修改头像
    handleHeaderShow() {
      this.headerShow = false;
    },
    // 修改完头像
    saveHeader() {
      this.headerShow = false;
      this.getOne();
    },
    details(e) {
      // this.$router.push("./orderDetails");
      console.log("e", e);
      this.orderDetails = true;
      this.getCartOrderDetailAction({
        orderId: e.orderId,
      }).then((res) => {
        console.log("res", res);
        this.orderMsg = res.data;
      });
    },
    // 再次购买
    handleBuyAgain(cartItem) {
      let param={
        orderType:'buyagain',
        id:cartItem.clothCategory,
        orderId: cartItem.orderId,
      },routerJump;

      if (cartItem.orderType === 8) {
        routerJump=this.$router.resolve({path:'/peofessionalOrder',query:{...param,...{sizeCategoryId:cartItem.sizeCategoryId}}});
      } else if (cartItem.orderType === 7) {
        routerJump=this.$router.resolve({path:'/newOrder',query:{...param,...{type:cartItem.orderType}}});
      }else if (cartItem.orderType === 9) {
        routerJump=this.$router.resolve({path:'/dressWellDetails',query:{...param,...{id:cartItem.goodId}}});
      }
      window.open(routerJump.href,'_blank')
    }
  },
  mounted() {
    this.customerId = this.$route.query.id;
    this.getOne();
    this.listCustomerNote();
    this.getOrderCartList();
    this.listCustomerNotea();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-icon-ios-close {
  display: none;
}
/deep/.ivu-modal-body {
  padding: 0;
}
.title-box {
  height: 84px;
  text-align: center;
  font-size: 20px;
  font-family: Roboto;
  font-weight: 600;
  color: #081938;
  line-height: 84px;
  letter-spacing: 2px;
  // line-height: 84px;
  border-bottom: 1px solid #e6e8eb;
  position: relative;
  .iconguanbi {
    width: 84px;
    height: 84px;
    text-align: center;
    line-height: 84px;
    font-size: 14px;
    color: #081938;
    position: absolute;
    right: 0;
    top: 0;
    border-left: 1px solid #e6e8eb;
  }
}
.customer-details {
  font-family: Roboto;
  .title-box {
    height: 84px;
    text-align: center;
    font-size: 20px;
    font-family: Roboto;
    font-weight: 600;
    color: #081938;
    line-height: 84px;
    letter-spacing: 2px;
    // line-height: 84px;
    border-bottom: 1px solid #e6e8eb;
    position: relative;
    .iconguanbi {
      width: 84px;
      height: 84px;
      text-align: center;
      line-height: 84px;
      font-size: 14px;
      color: #081938;
      position: absolute;
      right: 0;
      top: 0;
      border-left: 1px solid #e6e8eb;
    }
  }
  .customer-content {
    width: 1420px;
    margin: 0 auto;
    min-height: 100vh;
    background: #fff;
    padding: 0 10px;
    margin-bottom: 10px;
  }
  .details {
    width: 300px;
    border-right: 1px solid rgba(0, 0, 0, 0.06);
    overflow: hidden;
    padding-bottom: 31px;
    .header {
      position: relative;
      width: 56px;
      height: 56px;
      margin: 30px auto 15px;
      .header-img {
        width: 56px;
        height: 56px;
        border-radius: 50%;
      }
      .edit-icon {
        width: 15px;
        height: 15px;
        color: #0a4dcc;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .name {
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      color: #081938;
      line-height: 16px;
      margin-bottom: 5px;
    }
    .gender {
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      color: #081938;
      line-height: 14px;
      opacity: 0.4;
    }
    .options {
      width: 144px;
      margin: 15px auto 25px;
      img {
        width: 28px;
        height: 28px;
      }
    }
    .msg {
      width: 220px;
      margin: 0 auto;
      > div {
        width: 80px;
        text-align: center;
      }
      .num {
        font-size: 14px;
        font-weight: 700;
        color: #081938;
        line-height: 16px;
        margin-bottom: 5px;
      }
      .label {
        opacity: 0.7;
        font-size: 12px;
        font-weight: 400;
        color: #081938;
        line-height: 14px;
      }
      .unit {
        opacity: 0.4;
        font-size: 10px;
        font-weight: 400;
        color: #081938;
        line-height: 11px;
        margin-top: 4px;
      }
    }
    .personal-informaion {
      width: 280px;
      border-top: 1px solid rgba(0, 0, 0, 0.06);
      margin-top: 25px;
      padding: 0 20px;
      .iconbianji {
        font-size: 12px;
        color: rgba(8, 25, 56, 0.4);
      }
    }
    .informaion-item {
      margin-top: 20px;
      > div {
        word-wrap: break-word;
      }
      .informaion-label {
        margin-right: 10px;
        min-width: 60px;
        text-align: left;
        opacity: 0.7;
        font-size: 12px;
        font-weight: 400;
        text-align: left;
        color: #081938;
        line-height: 14px;
      }
      .informaion-content {
        font-size: 12px;
        font-weight: 400;
        text-align: right;
        color: #081938;
        line-height: 18px;
      }
    }
    .msg-title {
      font-size: 14px;
      font-weight: 700;
      text-align: left;
      color: #081938;
      line-height: 16px;
    }
  }
  .order {
    width: 820px;
    padding: 20px;
    .order-title {
      font-size: 14px;
      font-weight: 600;
      text-align: left;
      color: #081938;
      line-height: 16px;
      margin-bottom: 20px;
    }
  }
  .remark {
    width: 300px;
    background: #f8f8f8;
    padding: 20px 10px 20px 20px;
    .icontianjia {
      font-size: 16px;
      color: #0a4dcc;
    }
    .remark-top {
      margin-bottom: 20px;
    }
    .notes {
      width: 270px;
      border-left: 3px solid #0a4dcc;
      background: #fff;
      padding: 10px 20px;
      font-size: 14px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: left;
      color: #081938;
      line-height: 19px;
      margin-bottom: 10px;
      .iconshanchudizhi {
        font-size: 12px;
        color: rgba(8, 25, 56, 0.4);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/customerDetails/customerDetails.vue